export const FEDEX_TRACK = 'https://www.fedex.com/apps/fedextrack/?tracknumbers=';
export const CHR_TRACK = 'https://online.chrobinson.com/tracking/#/?trackingNumber=';
export const CHR_FREIGHT_METHODS = ['CHR-TRUCK-STD'];
export const FEDEX_FREIGHT_METHODS = ['FEDX-LTL-STD', 'FEDX-PARCEL-STD', 'FLEX-LTL-STD'];